import { isApiError } from '@api/fetcher'

/** Human-readable message for any error thrown by the generated API client. */
export function errorMessage(error: unknown): string {
  if (isApiError(error)) {
    const body = error.body
    if (body && typeof body === 'object' && 'message' in body) {
      return String((body as { message: unknown }).message)
    }
    return error.message
  }
  return error instanceof Error ? error.message : String(error)
}
